import { remove, update } from 'ramda'
import { useCallback } from 'react'

export default function useFieldsArrayManager(fields, updateFields, defaultItem) {
  const add = useCallback(() => {
    updateFields([...fields, { ...defaultItem }])
  }, [fields, updateFields, defaultItem])

  const removeAt = useCallback(
    (index) => {
      updateFields(remove(index, 1, fields))
    },
    [fields, updateFields],
  )

  const updateAt = useCallback(
    ({ idx, field, values }) => {
      const updatedField = {
        ...field,
        ...values,
      }
      const updatedFields = update(idx, updatedField, fields)
      updateFields(updatedFields)
    },
    [fields, updateFields],
  )

  return { add, removeAt, updateAt }
}
